
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 18a8 8 0 10-8-8 8.024 8.024 0 008 8z","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10 6.316v5","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9.995 13.333h.009","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    